"use client";
import { useMutation } from "@apollo/client/react";
import { faBan } from "@fortawesome/pro-solid-svg-icons";

import { Button } from "@/components";
import { MUTATE_ANIMATION } from "@/gql/queries/mutate-animation";

const BlacklistAnimationButton = ({ animationId }: { animationId: number }) => {
  const [mutateAnimation] = useMutation(MUTATE_ANIMATION);

  const blacklistAnimation = () => {
    // TODO:
    mutateAnimation({
      variables: { id: animationId, public: false, blacklisted: true },
    });
  };

  return (
    <Button icon={faBan} type="negative" onClick={blacklistAnimation}>
      Blacklist
    </Button>
  );
};

export { BlacklistAnimationButton };
